import Model from '@/models/Model'

export default class AInvoiceNumber extends Model {
    resource() {
        return 'invoice_number'
    }
}
